import React from 'react';

interface CloudNetworkIconProps {
  className?: string;
  size?: number;
}

const CloudNetworkIcon: React.FC<CloudNetworkIconProps> = ({ className = "", size = 24 }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 128 128"
      className={className}
      fill="currentColor"
    >
      <path d="M102.151,80.3a7.044,7.044,0,0,0-4.744,1.84L90.568,77.97V68.11h7.241a12.94,12.94,0,0,0,0-25.88H95.788a15.731,15.731,0,0,0-19.15-10.3,23.225,23.225,0,0,0-44.82,8.552c0,.563.026,1.139.078,1.75H30.188a12.94,12.94,0,0,0,0,25.88h7.241v9.86L30.59,82.137a7.1,7.1,0,1,0,1.938,2.916l7.561-4.606a1.749,1.749,0,0,0,.84-1.494V68.11H51.248V83.428l-4.582,5.265a7.018,7.018,0,0,0-2.987-.671,7.112,7.112,0,1,0,5.7,2.891l4.944-5.682a1.743,1.743,0,0,0,.43-1.148V68.11h7.5V96.87a7.083,7.083,0,1,0,3.5,0V68.11h7.986V84.036a1.753,1.753,0,0,0,.43,1.149l4.7,5.4a7.124,7.124,0,1,0,2.844-2.063l-4.477-5.145V68.11h9.834V78.953a1.749,1.749,0,0,0,.84,1.494l7.561,4.606a7.078,7.078,0,1,0,6.682-4.756ZM25.845,90.964a3.584,3.584,0,1,1,3.584-3.584A3.587,3.587,0,0,1,25.845,90.964ZM43.679,98.69a3.584,3.584,0,1,1,3.583-3.584A3.588,3.588,0,0,1,43.679,98.69Zm23.9,5.036A3.583,3.583,0,1,1,64,100.143,3.587,3.587,0,0,1,67.581,103.726Zm20.32-8.62a3.584,3.584,0,1,1-3.583-3.584A3.587,3.587,0,0,1,87.9,95.106ZM20.748,55.17a9.451,9.451,0,0,1,9.44-9.44h3.69a1.749,1.749,0,0,0,1.728-2.022,20.619,20.619,0,0,1-.288-3.228,19.723,19.723,0,0,1,38.568-5.826,1.75,1.75,0,0,0,2.329,1.108,12.234,12.234,0,0,1,16.538,8.61,1.749,1.749,0,0,0,1.7,1.358h3.351a9.44,9.44,0,0,1,0,18.88H75.717a1.187,1.187,0,0,0-.465,0H64.231a1.192,1.192,0,0,0-.466,0H30.188A9.451,9.451,0,0,1,20.748,55.17Zm81.4,35.794a3.584,3.584,0,1,1,3.583-3.584A3.588,3.588,0,0,1,102.151,90.964Z"/>
    </svg>
  );
};

export default CloudNetworkIcon;
